/**
 * Approval Notes (OR-1244) — closes the right column (Andressa, 4-ago; it used
 * to run full-width below the grid). Per the latest Figma it holds only the
 * free-text remarks; Probability to Bind moved to Premium and the
 * Referral/Approval dates to their own "Referral & Approval Dates" card. Notes
 * are capped at 600 chars.
 */
import { CharCountTextArea } from "../../../../components/char-count-textarea";
import { FormGroup } from "../../../../components/form-group";

const MAX_NOTES_LENGTH = 600;

interface ApprovalNotesCardProps {
    notes: string;
    onNotesChange: (value: string) => void;
}

export function ApprovalNotesCard({ notes, onNotesChange }: ApprovalNotesCardProps) {
    return (
        <FormGroup title="Approval Notes" data-autotest="premium-selection-approval-notes-card">
            <CharCountTextArea
                label="Notes / Remarks"
                value={notes}
                onChange={onNotesChange}
                maxLength={MAX_NOTES_LENGTH}
                placeholder="Enter notes"
                rows={4}
                data-autotest="premium-selection-approval-notes-textarea"
            />
        </FormGroup>
    );
}
